import { useKorintModuleConfig } from 'korint-sdk/react';
import { useMemo } from 'react';
import { PolicyTable } from '../../components/module-elements/PolicyTable/PolicyTable';

export function ArchivedNewBusinessModule() {
  const ongoingNewBusiness = useKorintModuleConfig('ongoingNewBusiness');

  const archivedBaseFilters = useMemo(
    () => ({
      ...ongoingNewBusiness.baseFilters,
      viewType: 'archivedNewBusiness' as const,
    }),
    [ongoingNewBusiness.baseFilters],
  );

  return (
    <PolicyTable
      filtersConfig={ongoingNewBusiness.filtersConfig}
      baseFilters={archivedBaseFilters}
      expandBrokerageFirm={ongoingNewBusiness.expandBrokerageFirm}
      expandCustomers={ongoingNewBusiness.expandCustomers}
      expandAssets={ongoingNewBusiness.expandAssets}
      columns={ongoingNewBusiness.columns}
      initialFilters={ongoingNewBusiness.initialFilters}
    />
  );
}
